import type { VipLevel } from "../types";

const VIP_CONFIG: Record<
  VipLevel,
  { label: string; className: string; icon: string }
> = {
  standard: {
    label: "注册客户 Registered",
    icon: "",
    className: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400",
  },
  silver: {
    label: "银牌 Silver",
    icon: "🥈",
    className:
      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  },
  gold: {
    label: "金牌 Gold",
    icon: "🥇",
    className:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
  },
  platinum: {
    label: "铂金 Platinum",
    icon: "💎",
    className:
      "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  },
  diamond: {
    label: "钻石 Diamond",
    icon: "👑",
    className:
      "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400",
  },
};

export const VipBadge = ({ level }: { level: string }) => {
  const config =
    VIP_CONFIG[(level as VipLevel) ?? "standard"] ?? VIP_CONFIG.standard;
  if (level === "standard") return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}
    >
      {config.icon} {config.label}
    </span>
  );
};

export const VIP_THRESHOLDS: { level: VipLevel; min: number; label: string }[] =
  [
    { level: "standard", min: 0, label: "注册客户 Registered (< $500)" },
    { level: "silver", min: 500, label: "银牌 Silver ($500 – $1,999)" },
    { level: "gold", min: 2000, label: "金牌 Gold ($2,000 – $4,999)" },
    { level: "platinum", min: 5000, label: "铂金 Platinum ($5,000 – $9,999)" },
    { level: "diamond", min: 10000, label: "钻石 Diamond ($10,000+)" },
  ];
